// Shared meal plan constants used across shef-api and shef-web
// Keep these values in sync with product requirements.

// Minimum total mains (units * servings) required for a valid meal plan selection in flows
// where we want to ensure enough meals per week.
export const MIN_TOTAL_UNITS_FOR_MEAL_PLAN = 4;

// Backend filtering thresholds by format when add-ons are disabled
export const MIN_MAINS_FOR_FLEXIBLE_SIDES_GROUP_ORDER = 4;
export const MIN_MAINS_FOR_MAINS_PLUS_SIDES_GROUP_ORDER = 3;
